import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import * as Queries from 'web-app/react/plans/debt-report/queries';
import {getApolloClient} from 'web-app/api/clients/famly-app';

import {
    type GetBillPayerListingQuery,
    type GetBillPayerListingQueryVariables,
} from '../debt-report/__generated__/queries.api-types';
import {type BillPayerWithBalanceGQL} from './bill-payer-converter';

export const fetchDebtReportOverview = (
    institutionId: string,
    asOf: string,
    includeCreditNotesAndCancelledInvoicesInBalance: boolean,
) =>
    RESTClient.getAuthenticatedObservable(`v2/invoicing/${institutionId}/debtReport/chart`, {
        asOf,
        includeCreditNotesAndCancelledInvoicesInBalance,
    });

const BILL_PAYERS_FETCH_LIMIT = 100;

export const fetchAllBillPayersFromGQL = (
    institutionId: string,
    asOf: string,
    includeCreditNotesAndCancelledInvoicesInBalance: boolean,
) => {
    return fetchBillPayersFromGQL(institutionId, asOf, includeCreditNotesAndCancelledInvoicesInBalance, [], null);
};

const fetchBillPayersFromGQL = (
    institutionId: string,
    asOf: string,
    includeCreditNotesAndCancelledInvoicesInBalance: boolean,
    existingData: BillPayerWithBalanceGQL[],
    next?: string | null,
): Promise<BillPayerWithBalanceGQL[]> => {
    return getApolloClient()
        .query<GetBillPayerListingQuery, GetBillPayerListingQueryVariables>({
            query: Queries.GetBillPayersByInstitutionSetId,
            variables: {
                institutionSetIds: [institutionId],
                asOfDate: asOf,
                includeCreditNotesAndCancelledInvoicesInBalance,
                pageSize: BILL_PAYERS_FETCH_LIMIT,
                next,
            },
        })
        .then(({data: billPayersData}) => {
            const collectedData = existingData?.concat(billPayersData.billPayers.byInstitutionSetIds.results);
            if (billPayersData.billPayers.byInstitutionSetIds.next !== null) {
                return fetchBillPayersFromGQL(
                    institutionId,
                    asOf,
                    includeCreditNotesAndCancelledInvoicesInBalance,
                    collectedData,
                    billPayersData.billPayers.byInstitutionSetIds.next,
                );
            }
            return collectedData;
        });
};

export const fetchBalanceInformationForBillPayers = (
    institutionId: string,
    asOf: string, // YYYY-MM-DD
    includeCreditNotesAndCancelledInvoicesInBalance: boolean,
    billPayerIds: string[],
    expectedPaymentIds?: string[],
    unexpectedPaymentIds?: string[],
    expectedInvoiceIds?: string[],
    unexpectedInvoiceIds?: string[],
) => {
    return RESTClient.getAuthenticated(`v2/invoicing/${institutionId}/debtReport/details`, {
        billPayerIds,
        asOf,
        includeCreditNotesAndCancelledInvoicesInBalance,
        expectedPaymentIds,
        unexpectedPaymentIds,
        expectedInvoiceIds,
        unexpectedInvoiceIds,
    }).then(result => {
        return result;
    });
};
